import { render, staticRenderFns } from "./AppCollectionItem.vue?vue&type=template&id=31bf8317&scoped=true&"
import script from "./AppCollectionItem.vue?vue&type=script&lang=ts&"
export * from "./AppCollectionItem.vue?vue&type=script&lang=ts&"
import style0 from "./AppCollectionItem.vue?vue&type=style&index=0&id=31bf8317&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bf8317",
  null
  
)

export default component.exports